var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 1.02571C28.3333 0.85904 31 1.42571 31 5.02571C31 8.62571 31 11.8591 31 13.0258C31 14.0258 32.2 16.0258 37 16.0258C35 16.0258 31 16.6258 31 19.0258C31 21.4258 31 25.3591 31 27.0258C31 28.3591 30.2 31.0258 27 31.0258",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.02571C8.66667 0.85904 6 1.42571 6 5.02571C6 8.62571 6 11.8591 6 13.0258C6 14.0258 4.8 16.0258 0 16.0258C2 16.0258 6 16.6258 6 19.0258C6 21.4258 6 25.3591 6 27.0258C6 28.3591 6.8 31.0258 10 31.0258",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDevelopment);
export default __webpack_public_path__ + "static/media/icon-development.950453ef0bc7c40f988be4a281640f8c.svg";
export { ForwardRef as ReactComponent };